module.exports = __webpack_public_path__ + "img/2.2971f6d0.png";